export default __webpack_public_path__ + "images/085016e2d20877c0bfc609d3794b6c3e.svg";